  // function toggleFeature(button) {
  //   const currentItem = button.closest('.feature-mobile-item');
  //   const description = currentItem.querySelector('.feature-description');

  //   document.querySelectorAll('.feature-description').forEach(desc => {
  //     if (desc !== description) desc.style.display = 'none';
  //   });

  //   const isVisible = description.style.display === 'block';
  //   document.querySelectorAll('.feature-description').forEach(desc => desc.style.display = 'none');

  //   if (!isVisible) {
  //     description.style.display = 'block';
  //   }
  // }

  // function closeFeature(closeBtn) {
  //   const description = closeBtn.closest('.feature-description');
  //   if (description) description.style.display = 'none';
  // }
  function toggleFeature(button) {
  const currentItem = button.closest('.feature-mobile-item');
  const description = currentItem.querySelector('.feature-description');

  // Hide all descriptions and remove 'active' from all items
  document.querySelectorAll('.feature-description').forEach(desc => {
    desc.style.display = 'none';
  });
  document.querySelectorAll('.feature-mobile-item').forEach(item => {
    item.classList.remove('active');
  });

  const isVisible = description.style.display === 'block';

  // If the clicked item was not already visible, show it and add 'active'
  if (!isVisible) {
    description.style.display = 'block';
    currentItem.classList.add('active');
  }
}

function closeFeature(closeBtn) {
  const description = closeBtn.closest('.feature-description');
  if (description) {
    description.style.display = 'none';

    // Remove 'active' class from its parent item
    const parentItem = description.closest('.feature-mobile-item');
    if (parentItem) parentItem.classList.remove('active');
  }
}
